import { render, staticRenderFns } from "./RowBlockBuyingAccidentInsurance.vue?vue&type=template&id=38d07a6e&"
import script from "./RowBlockBuyingAccidentInsurance.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingAccidentInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports